// @ts-nocheck
import {
  Component,
  Input,
  Renderer2,
  ElementRef,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'lib-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  exportAs: 'libButton',
})
export class ButtonComponent implements AfterViewInit {
  @ViewChild('button', { static: true }) button: ElementRef;

  @ViewChild('button', { static: true }) content: ElementRef;

  @Input() prefixIcon: string;

  @Input() suffixIcon: string;

  @Input() badgeText: string;

  @Input() badgeClass: string;

  @Input() type: 'button' | 'submit' = 'button';

  @Input() fullWidth: boolean = false;

  @Input() centered: boolean = false;

  @Input() small: boolean = false;

  @Output() buttonClick: EventEmitter<MouseEvent | TouchEvent> = new EventEmitter();

  @Input() theme:
    | 'primary'
    | 'accent'
    | 'warn'
    | 'link'
    | 'reverse'
    | 'stroked'
    | 'stroked-primary'
    | 'stroked-accent'
    | 'stroked-warn'
    | 'stroked-link'
    | 'stroked-reverse'
    | 'flat'
    | 'flat-primary'
    | 'flat-accent'
    | 'flat-reverse'
    | 'flat-warn'
    | 'flat-link'
    | 'flat-dark'
    | 'flat-reverse'
    | 'raised'
    | 'raised-primary'
    | 'raised-accent'
    | 'raised-reverse'
    | 'raised-warn'
    | 'raised-link'
    | 'raised-dark'
    | 'raised-reverse';

  @Input()
  set disabled(value: string | boolean) {
    this.isDisabled = value === '' || value === 'true' || value === true;
  }

  @Input() testAttribute: string = 'button';

  get class(): string {
    return `lib-button${this.theme ? `-${this.theme}` : ''}
      ${(this.fullWidth || this.fullWidth === '') ? 'is-full-width' : ''}
      ${(this.centered || this.centered === '') ? 'is-centered' : ''}
      ${(this.small || this.small === '') ? 'is-small' : ''}`;
  }

  isDisabled: boolean;

  constructor(private renderer: Renderer2, private element: ElementRef) { }

  ngAfterViewInit() {
    if (!this.content.nativeElement.textContent) {
      this.renderer.setStyle(this.content.nativeElement, 'padding', '0');
    }
  }

  onButtonClick($event) {
    if (this.isDisabled) {
      return;
    }
    this.buttonClick.emit($event);
  }
}
